<template>
  <div class="urlParse-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span v-if="$route.query.id">编辑</span>
        <span v-else>新增</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'urlParse' })"
        >
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="save">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="100px"
          @submit.native.prevent
          :model="formData"
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="规则名称" prop="name">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item label="host" prop="host">
            <el-input v-model="formData.host"></el-input>
          </el-form-item>
          <el-form-item label="版本" prop="version">
            <el-input v-model="formData.version"></el-input>
          </el-form-item>
          <el-form-item label="js文件" prop="model">
            <template v-if="formData.js.length">
              <p v-for="(file, index) in formData.js" :key="index">
                {{ file.url }}
                <span
                  class="el-icon-close urlParse-del-urlFile"
                  @click.stop="delFile('js', index)"
                ></span>
              </p>
            </template>
            <el-upload
              action=""
              :auto-upload="false"
              multiple
              :on-change="importJsFile"
              :show-file-list="false"
              accept=".js"
            >
              <el-button size="small" type="primary">导入</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="css文件" prop="modelGroups">
            <template v-if="formData.css.length">
              <p v-for="(file, index) in formData.css" :key="index">
                {{ file.url }}
                <span
                  class="el-icon-close urlParse-del-urlFile"
                  @click.stop="delFile('css', index)"
                ></span>
              </p>
            </template>
            <el-upload
              action=""
              :auto-upload="false"
              multiple
              :on-change="importCssFile"
              :show-file-list="false"
              accept=".css"
            >
              <el-button size="small" type="primary">导入</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BMF from "browser-md5-file";
import { uploadOss } from "@/utils/aliyun";
const bmf = new BMF();
export default {
  data() {
    return {
      formData: {
        name: "",
        host: "",
        version: "",
        js: [],
        css: []
      },
      params: {},
      rules: {
        // pic_address: [
        //   { required: true, message: "请选择广告封面", trigger: "change" }
        // ]
      }
    };
  },
  methods: {
    importJsFile(file, fileList) {
      this.formData.js = [...this.formData.js, file];
    },
    importCssFile(file, fileList) {
      this.formData.css = [...this.formData.css, file];
    },

    delFile(type, index) {
      this.formData[type].splice(index, 1);
    },

    getUrlParseInfoDetails() {
      this.$http.getUrlParseInfoDetails(this.$route.query.id).then(res => {
        this.formData = Object.assign(this.formData, res.data);
      });
    },

    async save() {
      this.params = Object.assign({}, this.formData);
      this.params.js = await this.uploadAliyun(this.formData.js, "urlParse/js");
      this.params.css = await this.uploadAliyun(
        this.formData.css,
        "urlParse/css"
      );
      if (this.$route.query.id) {
        this.edit();
      } else {
        this.create();
      }
    },

    uploadAliyun(files, key) {
      return new Promise(async (resolve, reject) => {
        try {
          let arr = [];
          for (let file of files) {
            if (file.md5) {
              arr = [...arr, file];
            } else {
              let md5 = await this.getMd5(file.raw);
              // 上传
              let res = await uploadOss(file, "onyx-static", key);
              arr = [...arr, { url: res, md5, displayName: file.name }];
            }
          }
          resolve(arr);
        } catch (error) {
          reject(error);
        }
      });
    },

    getMd5(file) {
      return new Promise((resolve, reject) => {
        bmf.md5(
          file,
          (err, md5) => {
            resolve(md5);
            reject(err);
          },
          progress => {
            // console.log("progress number:", progress);
          }
        );
      });
    },

    create() {
      this.$http.createUrlParseInfo(this.params).then(res => {
        this.elMsg("创建成功", "success");
        this.$router.push({ name: "urlParse" });
      });
    },

    edit() {
      this.$http
        .updateUrlParseInfo(this.$route.query.id, this.params)
        .then(res => {
          this.elMsg("编辑成功", "success");
          this.$router.push({ name: "urlParse" });
        });
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.getUrlParseInfoDetails();
    }
  }
};
</script>

<style lang="scss">
.urlParse-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .urlParse-del-urlFile {
      color: red;
      cursor: pointer;
    }
    .pic {
      .pic-item {
        /* position: relative; */
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .global-button-style {
        width: 80px;
        height: 30px;
      }
      .urlParse-edit-cover {
        position: relative;
        width: 200px;
        height: 300px;
        overflow: hidden;
        margin: 10px 0;
        border: 2px dashed #ccc;
        border-radius: 10px;
        &:hover {
          border-color: #bb745c;
        }
        > img {
          width: 100%;
          height: 100%;
        }
        > .urlParse-edit-cover-icon {
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #bb745c;
        }
        > .urlParse-edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.4);
            .urlParse-edit-upload-btn {
              display: block;
            }
          }
          .urlParse-edit-upload-btn {
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            text-align: center;
            line-height: 300px;
            > .el-upload--text {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .add-img {
        width: 70px;
        height: 40px;
        font-size: 22px;
        line-height: 43px;
        color: #fff;
        cursor: pointer;
        background-color: #bb745c;
      }
    }
  }
}
</style>
